import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'


// 引入全局类
import utils from '@/utils/utils.js'
import api from '@/api/index.js'

Vue.prototype.$utils = utils;
Vue.prototype.$api = api;


//引入filter
import * as filters from '@/utils/filters.js'
// import 'babel-polyfill' //兼容IE11
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// 引入公共组件
// import Header from '@/components/Header';
// import Foot from '@/components/Foot';
// import Nav from '@/components/Nav';

// 全局注册公共组件
// Vue.component(Header.name, Header);
// Vue.component(Nav.name, Nav);
// Vue.component(Foot.name, Foot);

// 滚动条插件
// Vue.use(window["vuescroll"])

// fade/zoom 等
import 'element-ui/lib/theme-chalk/base.css';
// collapse 展开折叠
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';

// 轮播
import VueAwesomeSwiper from 'vue-awesome-swiper'
// require styles
// import 'swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper, /* { default global options } */)

// 按需加载element组件
import {  Table ,
          TableColumn , 
          Rate ,
          Dialog,
          Upload,
          Button,
} from 'element-ui';
Vue.component(Table.name, Table);
Vue.component(TableColumn.name, TableColumn);
Vue.component(Rate.name, Rate);
Vue.component(CollapseTransition.name, CollapseTransition)
Vue.component(Dialog.name, Dialog)
Vue.component(Upload.name, Upload)
Vue.component(Button.name, Button)


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
